import script from "./InviteUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteUserModal.vue?vue&type=script&setup=true&lang=js"

import "./InviteUserModal.vue?vue&type=style&index=0&id=0ec024a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec024a6"]])

export default __exports__